// Derives a file type token (e.g. "PDF", "JPG") from a filename's extension.
// Used as a fallback for FileIcon when the API doesn't send an explicit type.
export const fileTypeFromName = (name: string): string => {
  const extension = name.split(".").pop();
  if (!extension || extension === name) return "";
  return extension.toUpperCase();
};
